import { css as o } from "@microsoft/fast-element";
import { normalize as n } from "../common/normalize.js";
import { display as e } from "@matrix42/fast-foundation";
import { slotStyleSheetBehavior as i } from "../common/behaviors/slot-style-sheet-behavior.js";
import { inputHostWithNativeControlStyles as r, inputControlStyles as l, inputHintStyles as s, inputTextStyles as p, inputIconStyles as a } from "../styles/input.styles.js";
import { labelStyles as m } from "../styles/label.styles.js";
const c = o`
  :host {
    /* Layout */
    gap: 0;
  }
`, w = (u) => o`
    ${n}
    ${e("flex")}
    ${r(".root", ".control")}
    ${l(".root")}
    ${s(".hint")}
    ${p(".control")}
    ${m(".label")}
    ${a()}
    .control {
      /* Base */
      -moz-appearance: textfield;
    }

    .control::-webkit-outer-spin-button,
    .control::-webkit-inner-spin-button {
      /* Base */
      -webkit-appearance: none;
      margin: 0;
    }
  `.withBehaviors(
  i(
    (t) => !t.hasContent("content") && !t.hasContent("hint"),
    c
  )
);
export {
  c as UnlabeledInputStyles,
  w as inputStyles
};
